export default __webpack_public_path__ + "static/media/VIE.40fade36.svg";